import { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';

/**
 * A two-tap delete for the Needs-attention rows (JIM-0919-11). The first
 * tap arms it ("Tap again to delete"), the second one deletes; it disarms on
 * its own after a few seconds. No modal — this is a phone, and the thing
 * being thrown away is a draft nobody finished.
 */
export function DismissButton({
  label = 'Dismiss',
  confirmLabel = 'Tap again to delete',
  onConfirm,
  busy = false,
  busyLabel = 'Deleting…',
  ariaLabel,
}: {
  label?: string;
  confirmLabel?: string;
  onConfirm: () => void;
  busy?: boolean;
  busyLabel?: string;
  ariaLabel: string;
}) {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const timer = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(timer);
  }, [armed]);

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-pressed={armed}
      disabled={busy}
      onClick={() => {
        if (armed) {
          setArmed(false);
          onConfirm();
        } else {
          setArmed(true);
        }
      }}
      className={`inline-flex items-center gap-1 px-2.5 py-2 rounded-lg text-xs font-semibold transition-colors flex-shrink-0 disabled:opacity-60 ${
        armed
          ? 'bg-danger-600 hover:bg-danger-700 text-white'
          : 'text-slate-500 dark:text-slate-400 hover:bg-slate-200/60 dark:hover:bg-slate-700'
      }`}
    >
      <Trash2 className="w-3.5 h-3.5" />
      {busy ? busyLabel : armed ? confirmLabel : label}
    </button>
  );
}
